/* lua.js generated code 0.3.0 */

require("clover/animation/CountDownAnimation")
require("clover/panel/component/common/UIButton")
LoadingPanel = xClass("LoadingPanel", UIButton, cc.LayerColor)
LoadingPanelEvent = table([1, "Close", "LOADINGPANELEVENT.CLOSE"])
var panelInstance = null
var sceneList = table()
var waitEndList = table()
var _loadingInit = false
LoadingPanel.onEnterHomeScene = function () {

    if (_loadingInit) {
        return
    }
    _loadingInit = true
    var scene = require("clover/scene/HomeScene").getInstance()
    var useLess, enterHandler, exitHandler
    [useLess, enterHandler] = scene.on(BaseSceneEvent.Enter, function (evt) {
        LoadingPanel.onEnterScene(evt)
    })
    [useLess, exitHandler] = scene.on(BaseSceneEvent.Exit, function (evt) {
        LoadingPanel.onExitScene(evt)
    })
    table.insert(sceneList, table(
        [1, "scene", scene],
        [1, "enter", enterHandler],
        [1, "exit", exitHandler]
    ))
    cc.Director.getInstance().registerSceneEventListener(function (evtName, oldScene, newScene) {
        LoadingPanel.onDirectorSceneEvent(evtName, oldScene, newScene)
    })
}
LoadingPanel.onEnterScene = function (evt) {
    if (panelInstance) {
        evt.target.addChild(panelInstance, 300030)
    }
}
LoadingPanel.onExitScene = function (evt) {
    if (panelInstance) {
        panelInstance.removeFromParent(false)
    }
    for (var i = 1, v = waitEndList[1]; v; i++ , v = waitEndList[i]) {
        if (v.scene === evt.target) {
            v.scene.removeEventListener(v.enter)
            v.scene.removeEventListener(v.exit)
        }
        table.removebyvalue(waitEndList, v)
        break
    }
}
LoadingPanel.onDirectorSceneEvent = function (evtName, oldScene, newScene) {
    if (evtName === "pushScene") {
        var useLess, enterHandler, exitHandler
        [useLess, enterHandler] = newScene.on(BaseSceneEvent.Enter, function (evt) {
            LoadingPanel.onEnterScene(evt)
        })
        [useLess, exitHandler] = newScene.on(BaseSceneEvent.Exit, function (evt) {
            LoadingPanel.onExitScene(evt)
        })
    } else if (evtName === "popScene") {
        for (var i = 1, v = sceneList[1]; v; i++ , v = sceneList[i]) {
            if (v.scene === oldScene) {
                table.insert(waitEndList, v)
                table.removebyvalue(sceneList, v)
                break
            }
        }
    } else if (evtName === "replaceScene") {
        var useLess, enterHandler, exitHandler
        [useLess, enterHandler] = newScene.on(BaseSceneEvent.Enter, function (evt) {
            LoadingPanel.onEnterScene(evt)
        })
        [useLess, exitHandler] = newScene.on(BaseSceneEvent.Exit, function (evt) {
            LoadingPanel.onExitScene(evt)
        })
        table.insert(sceneList, table(
            [1, "scene", newScene],
            [1, "enter", enterHandler],
            [1, "exit", exitHandler]
        ))
        for (var i = 1, v = sceneList[1]; v; i++ , v = sceneList[i]) {
            if (v.scene === oldScene) {
                table.insert(waitEndList, v)
                table.removebyvalue(sceneList, v)
                break
            }
        }
    }
}
// 这个getInstance是用来确认和获取实例的 不是用来创建实例的 不要随便调用
LoadingPanel.getInstance = function () {
    return panelInstance
}
LoadingPanel.prototype.ctor = function () {
    var self = this
    self.closeEnabled = true
    self.waitingAnim = true
    cc.LayerColor.prototype.ctor.call(self)
    UIButton.prototype.ctor.call(self, self, true)
    self.init()
}

LoadingPanel.prototype.init = function () {
    var self = this
    self.setOpacity(0)
    var vSize = cc.Director.getInstance().getVisibleSize()
    self.setContentSize(cc.size(vSize.width, vSize.height))
    self.animation = CountDownAnimation._createNetworkAnimationLayer(function () {
        self.dispatchEvent(table([1, "name", LoadingPanelEvent.Close]))
    })
    self.animation.setName("anim")
    self.addChild(self.animation)
}

LoadingPanel.prototype.playAnim = function () {
    var self = this
    let closeBtn = self.animation.getChildByName("anim").getChildByName("close");
    if (closeBtn != null)
        closeBtn.setVisible(false)
    self.animation.setVisible(false)
    self.runAction(cc.Sequence.create(cc.DelayTime.create(0.5), cc.CallFunc.create(function () {
        self.animation.setVisible(true)
    }), cc.DelayTime.create(4.5), cc.CallFunc.create(function () {
        self.waitingAnim = false
        if (closeBtn != null)
            closeBtn.setVisible(self.closeEnabled)
    })))
}

LoadingPanel.prototype.setCloseEnabled = function (enabled) {
    var self = this
    self.closeEnabled = enabled
    if (!self.waitingAnim) {
        var animation = self.getChildByName("anim")
        var close = animation.getChildByName("anim").getChildByName("close")
        close.setVisible(enabled)
    }
}
LoadingPanel.prototype.setString = function (text) {
    var self = this
    var animation = self.getChildByName("anim")
    var label = animation.getChildByName("anim").getChildByName("label")
    label.setString(text || getText("connect.doing.tips1"))
}
LoadingPanel.prototype.onKeyBackClicked = function () {
    var self = this
    if (!self.waitingAnim) {
        var animation = self.getChildByName("anim")
        var close = animation.getChildByName("anim").getChildByName("close")
        if (animation.isVisible() && close.isVisible()) {
            self.dispatchEvent(table([1, "name", LoadingPanelEvent.Close]))
        }
    }
}
LoadingPanel.prototype.show = function () {
    var self = this
    var scene = cc.Director.getInstance().getRunningScene()
    if (scene) {
        scene.addChild(self, 300030)
        self.playAnim()
        self.retain()
    }
    panelInstance = self
}
LoadingPanel.prototype.remove = function (cleanup = false) {
    var self = this
    self.release()
    self.removeFromParent(cleanup)
    panelInstance = null
}
module.exports = table([0, LoadingPanel], [0, LoadingPanelEvent])
